module.exports = __webpack_public_path__ + "static/3M_2020_2021_Bondholder_Reporting-f9e4650acab00b3dea397dbd79b1424f.pdf";